var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticStyle: { height: "48px", "flex-wrap": "nowrap" } },
        [
          _c(
            "v-layout",
            { staticClass: "unitImagesHeader", attrs: { row: "" } },
            [
              _c("v-flex", [
                _c("span", { staticClass: "unitImagesName" }, [
                  _vm._v("IMAGES OF CLIENTS IN UNIT " + _vm._s(_vm.unit.name))
                ])
              ])
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { xs: "", icon: "", flat: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.close()
                }
              }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        { staticStyle: { height: "calc(90vh - 96px)", "overflow-y": "auto" } },
        [
          _vm.unit
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                _vm._l(_vm.unitClientSummaries, function(
                  unitClientSummary,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "unitClientInfoContainer",
                      attrs: { "pa-1": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("client-image", {
                            staticClass: "unitClientImage",
                            attrs: {
                              clientID:
                                unitClientSummary.clientSummary.clientID.id,
                              clientName:
                                unitClientSummary.clientSummary.clientName
                            }
                          }),
                          _c("span", { staticClass: "unitClientInfo" }, [
                            _c("div", { staticClass: "unitClientName" }, [
                              _vm._v(
                                _vm._s(
                                  unitClientSummary.clientSummary.clientName
                                    .first +
                                    " " +
                                    unitClientSummary.clientSummary.clientName
                                      .last
                                )
                              )
                            ]),
                            _c("div", { staticClass: "unitClientRoomName" }, [
                              _vm._v(
                                "Room " + _vm._s(unitClientSummary.roomName)
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-card-actions")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }